<template>
    <header
        class="flex items-center justify-between gap-4 border-b border-gray-200 bg-white px-6 py-3 dark:border-gray-800 dark:bg-gray-900"
    >
        <div class="flex items-center gap-4">
            <button
                @click="$emit('openMenu')"
                class="text-gray-500 focus:outline-none lg:hidden dark:text-gray-400"
            >
                <svg
                    class="w-6 h-6"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 6H20M4 12H20M4 18H11"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>

            <div class="relative">
                <span class="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </span>

                <input
                    class="h-10 w-36 rounded-lg border border-gray-200 bg-gray-50 pl-10 pr-4 text-sm text-gray-700 placeholder-gray-400 focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/30 sm:w-64 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:placeholder-gray-500"
                    type="text"
                    placeholder="Rechercher"
                />
            </div>
        </div>

        <div class="flex items-center gap-2">
            <button
                @click="onToggleTheme"
                type="button"
                aria-label="Changer de thème"
                class="flex h-10 w-10 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 focus:outline-none dark:text-gray-400 dark:hover:bg-gray-800"
            >
                <font-awesome-icon :icon="['fas', isDark ? 'sun' : 'moon']" class="w-4 h-4"/>
            </button>
        </div>
    </header>
</template>

<script>

import { isDarkMode, toggleDarkMode } from '@/common/theme'

export default {
    data() {
        return {
            isDark: isDarkMode(),
        }
    },
    emits: ['openMenu'],
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        onToggleTheme() {
            this.isDark = toggleDarkMode();
        }
    },
};
</script>
